import initialData from "./initial-data";
import Cookie from 'js-cookie';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import axiosInstance, { handleRateLimitError } from './services/axiosConfig'
import qs from 'qs'
import hash from 'object-hash'
import { initializeCoverletter, setInitialData, setLoginHash, setMembershipData } from "./services/actions/actions";
import {SITE_DOMAIN, COOKIE_DOMAIN, PAID_SERVICES, ACCOUNT_SYNC} from "./constants/constants";
import { ucFirstWordOfSentence, setSleep, encryptNumber, getDateTime, getResumeName, getLetterName, isLocalStorageAvailable, updateUserDbResume, safeGetLocalStorage, safeSetLocalStorage, safeRemoveLocalStorage } from "./helper";
import { PDFHeaderFooter } from "./components/PDFHeaderFooter";
import * as Sentry from "@sentry/react";
export default class WpAPI {

    static initalEntityData = () => {
        // const savedResume = WpAPI.fetchActiveResume()
        // if (savedResume) {
        //     return _.merge({}, initialData, { resume: savedResume })
        // }
        return { ...initialData }
    }
    static fetchActiveResume = (dispatch, callback = false, forcereload = false) => {
        const loginHash = Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"});
        let currentResume = Cookie.get('current_resume', {domain: COOKIE_DOMAIN, path: "/"});
        let resumes = "{}";
        let offlineResumes = "[]";
        if (isLocalStorageAvailable()) {
            resumes = JSON.parse(safeGetLocalStorage('resumes', "{}"));
            offlineResumes = JSON.parse(safeGetLocalStorage('offlineResumes', '[]'));
        } else {
            console.warn("LocalStorage is not available.");
        }

        // If the user is logged in
        if (loginHash) {
            const frags = loginHash.split("|")
            let resumesOfUser = JSON.parse(safeGetLocalStorage(frags[0], '[]'));
            // If there is no resume saved for this user
            if (forcereload || !(resumesOfUser && _.isArray(resumesOfUser) && resumesOfUser.length > 0)) {
                //initialize the resumesOfUser with offlineResumes on login/signup
                resumesOfUser = offlineResumes;
                //set offlineResumes with blank array after assigning it to resumesOfUser
                safeSetLocalStorage('offlineResumes', '[]');
                //axiosInstance.post(`/api/user/get_user_meta/`, qs.stringify(
                axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(
                    {
                        action: 'rb_get_user_resume',
                        insecure: "cool",
                        cookie: loginHash,
                        //meta_key: "resume"
                        //Add userMeta Info for Free/Paid User.
                    }
                )).then(resplevelup => {
                    let res = resplevelup.data;
                    let resume = res.resume?.replace(/(\r\n|\n|\r)/gm, "");
                    let resTmp = JSON.parse(resume ? resume : "[]");
                    let resData = resTmp[0] ? resTmp[0] : {};
                    if (res.status == 'ok') {
                        //console.log('resData', resData)
                        // Update the meta data locally
                        _.forOwn(resData, (value, key) => {
                            value = updateUserDbResume(value);
                            resumesOfUser.push(key);
                            resumes[key] = value;
                        })

                        safeSetLocalStorage('resumes', JSON.stringify(resumes));
                        safeSetLocalStorage(frags[0], JSON.stringify(resumesOfUser))
                        // If template variable is given its asking for a new resume
                        // if (template) {
                        //     currentResume = uuidv4();
                        //     // Also set it into the cookie to make sure it persist
                        //     Cookie.set('current_resume', currentResume);
                        //     dispatch(setInitialData(loginHash, currentResume))
                        //     // dispatch(selectTemplate(WpUser.getProperTemplate(template)));
                        //     history.pushState({}, "Resume Builder — Create a resume for free in minutes", "/editor/")
                        // }
                        // // Now if the current resume exists then fine
                        // // otherwise start fresh
                        // else 
                        if (currentResume && resumes[currentResume]) {
                            dispatch(setInitialData(loginHash, currentResume, resumes[currentResume]))
                            // dispatch (setInitialData({resume:resData[currentResume]}))
                        } else {
                            currentResume = uuidv4();
                            // Also set it into the cookie to make sure it persist
                            Cookie.set('current_resume', currentResume, { domain: COOKIE_DOMAIN, path: '/' });
                            dispatch(setInitialData(loginHash, currentResume))
                        }
                    } else {
                        // If there is any error
                        // just fall back to create a fresh resume
                        currentResume = uuidv4();
                        // Also set it into the cookie to make sure it persist
                        Cookie.set('current_resume', currentResume, { domain: COOKIE_DOMAIN, path: '/' });
                        // dispatch ({resume:null})
                        dispatch(setInitialData(loginHash, currentResume))
                        // if (template) {
                        //     dispatch(selectTemplate(WpUser.getProperTemplate(template)));
                        //     history.pushState({}, "Resume Builder — Create a resume for free in minutes", "/editor/")
                        // }
                    }

                    if (typeof callback == 'function') { callback() }

                    // currentResume = uuidv4();
                    // // Also set it into the cookie to make sure it persist
                    // Cookie.set('current_resume', currentResume);
                    // store.dispatch(setInitialData(loginHash, currentResume))
                }).catch(() => {
                    // If there is any error
                    // just fall back to create a fresh resume
                    currentResume = uuidv4();
                    // Also set it into the cookie to make sure it persist
                    Cookie.set('current_resume', currentResume, { domain: COOKIE_DOMAIN, path: '/' });
                    // return ({resume:null})
                    dispatch(setInitialData(loginHash, currentResume))
                    if (typeof callback == 'function') callback()
                    // if (template) {
                    //     dispatch(selectTemplate(WpUser.getProperTemplate(template)));
                    //     history.pushState({}, "Resume Builder — Create a resume for free in minutes", "/editor/")
                    // }
                })

            }
            // else if(template){
            //     currentResume = uuidv4();
            //     // Also set it into the cookie to make sure it persist
            //     Cookie.set('current_resume', currentResume);
            //     dispatch(setInitialData(loginHash, currentResume))
            //     dispatch(selectTemplate(WpUser.getProperTemplate(template)));
            //     history.pushState({}, "Resume Builder — Create a resume for free in minutes", "/editor/" )
            // }
            // If there are resumes but there is no value for currentResume
            // of that value is invalid
            else if (!currentResume || !resumes[currentResume]) {
                // Create a new resume id
                currentResume = uuidv4();
                // Also set it into the cookie to make sure it persist
                Cookie.set('current_resume', currentResume, { domain: COOKIE_DOMAIN, path: '/' });
                dispatch(setInitialData(loginHash, currentResume))
                if (typeof callback == 'function') callback()
            }
            // If current resume is no in the user's bucket then add it
            else if (_.indexOf(resumesOfUser, currentResume) === -1) {
                resumesOfUser.push(currentResume)
                safeSetLocalStorage(frags[0], JSON.stringify(resumesOfUser))
                // Also set it into the cookie to make sure it persist
                Cookie.set('current_resume', currentResume, { domain: COOKIE_DOMAIN, path: '/' });
                dispatch(setInitialData(loginHash, currentResume, resumes[currentResume]))
                if (typeof callback == 'function') callback()
            } else {
                // Everything is there
                dispatch(setInitialData(loginHash, currentResume, resumes[currentResume]))
                if (typeof callback == 'function') callback()
            }
        } else {
            // Fix RESUMEORG-REACT-3W: localStorage might be null in private mode or restricted environments
            let offlineResumes = null;
            try {
                if (typeof window !== 'undefined' && window.localStorage) {
                    const offlineResumesData = localStorage.getItem('offlineResumes');
                    offlineResumes = offlineResumesData ? JSON.parse(offlineResumesData) : null;
                }
            } catch (error) {
                console.warn('localStorage not available in fetchActiveResume:', error.message);
                offlineResumes = null;
            }
            
            if (!currentResume) {
                currentResume = uuidv4();
                Cookie.set('current_resume', currentResume, { domain: COOKIE_DOMAIN, path: '/' });
                dispatch(setInitialData(loginHash ? loginHash : null, currentResume));
                if (typeof callback == 'function') callback()
            } else if (!(_.isArray(offlineResumes) && _.indexOf(offlineResumes, currentResume) !== -1 && resumes[currentResume])) {
                currentResume = uuidv4();
                Cookie.set('current_resume', currentResume, { domain: COOKIE_DOMAIN, path: '/' });
                // return resumes[currentResume]
                dispatch(setInitialData(loginHash ? loginHash : null, currentResume));
                if (typeof callback == 'function') callback()
            } else {
                console.log('set it from here')
                // return resumes[currentResume]
                dispatch(setInitialData(loginHash ? loginHash : null, currentResume, resumes[currentResume]))
                if (typeof callback == 'function') callback()
            }
        }
    }
    
    static getCurrentResume() {
        let cResume;
        let currentResume = Cookie.get('current_resume', {domain: COOKIE_DOMAIN, path: "/"});
        let resumes = {};
        if (isLocalStorageAvailable()) {
            resumes = localStorage.getItem('resumes');
            resumes = resumes ? JSON.parse(resumes) : {};
        }
        cResume = currentResume ? resumes[currentResume] : {};
        return cResume;
    }

    static getCurrentLetter() {
        let cLetter;
        let currentLetter = Cookie.get('current_letter', {domain: COOKIE_DOMAIN, path: "/"});
        let letters = JSON.parse(localStorage.getItem('letters'));
        letters = letters ? letters : {};
        cLetter = currentLetter ? letters[currentLetter] : {};
        return cLetter;
    }

    static saveState = (state, todb = false, assignResumeToCurrentId = true) => {
        let currentResume = Cookie.get('current_resume', {domain: COOKIE_DOMAIN, path: "/"});
        let resumes = JSON.parse(localStorage.getItem('resumes'));
        resumes = resumes ? resumes : {};

        if (currentResume) {
            // Update the resume
            if(assignResumeToCurrentId)
                resumes[currentResume] = state.resume;
            // console.log('save state',resumes)
            localStorage.setItem('resumes', JSON.stringify(JSON.parse(JSON.stringify(resumes))));
            if (state.loginHash) {
                const frags = state.loginHash.split("|")
                let resumesOfUser = JSON.parse(safeGetLocalStorage(frags[0], '[]'));
                resumesOfUser = _.isArray(resumesOfUser) ? resumesOfUser : [];

                if (_.indexOf(resumesOfUser, currentResume) === -1) {
                    resumesOfUser.push(currentResume);
                    localStorage.setItem(frags[0], JSON.stringify(resumesOfUser));
                }

                todb && WpAPI.saveMetaServer(resumesOfUser, resumes, state.loginHash);
            } else {
                let offlineResumes = JSON.parse(localStorage.getItem('offlineResumes'));
                offlineResumes = _.isArray(offlineResumes) ? offlineResumes : [];
                if (_.indexOf(offlineResumes, currentResume) === -1) {
                    offlineResumes.push(currentResume);
                    localStorage.setItem('offlineResumes', JSON.stringify(offlineResumes));
                }
            }
        }
    }
 
    static getNonce() {
        return axiosInstance.post('/api/get_nonce/',
            qs.stringify({
                controller: "user",
                method: "register"
            })
        )
    }
    static signUp(email, password, confirmpassword, token) {
        return new Promise((resolve, reject) => {
            let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
            if (emailRegex.test(email)) {
                if (password.length < 6) {
                    reject("Password is not valid")
                } else if (password !== confirmpassword) {
                    reject("Password and Confirm Password must match")
                } else if (!token.length) {
                    reject("Recaptcha token is not validated. Please refresh the page and try again.")
                } else {
                    WpAPI.getNonce().then(
                        function (nonce) {

                            // console.log(nounce.data.nonce);
                            // const email_fragments = email.split("@");
                            // const username = email_fragments.join(".");
                            const username = email;
                            axiosInstance.post(`/api/user/register/`, qs.stringify(
                                {
                                    insecure: "cool",
                                    username: username,
                                    user_pass: password,
                                    email: email,
                                    nonce: nonce.data.nonce,
                                    display_name: username,
                                    token: token,
                                    notify: "user"
                                }
                            )).then((resp) => {
                                //console.log(resp)
                                if (resp.data.status === 'ok') {
                                    const loginHash = resp.data.cookie;
                                    Cookie.set('rbuser', loginHash, { domain: COOKIE_DOMAIN, path: "/" });
                                    //stop tracking on trustpilot -- https://gitlab.dailyrssmail.com/growthlabs/resumebuilder.com-wpe/-/issues/1186
                                    //localStorage.setItem('tpuser', JSON.stringify(resp.data.user));
                                    resolve({
                                        loginHash: resp.data.cookie, 
                                        cookie_name: resp.data.cookie_name, 
                                        auth_cookie_name: resp.data.auth_cookie_name,
                                        user: resp.data.user
                                    })
                                } else {
                                    if (resp.data.error === 'Username already exists.') {
                                        reject("User already exists. Please use login or reset password to proceed");
                                    } else {
                                        reject(resp.data.error);
                                    }
                                }
                            }).catch((e) => {
                                reject("We encountered a problem. Please try again.");
                            })
                        }
                    )
                }
            } else {
                reject("Email is not valid")
            }
        })
    }
    static login(email, password) {
        return new Promise((resolve, reject) => {
            let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
            if (emailRegex.test(email)) {
                if (password.length < 6) {
                    reject("Password is not valid")
                } else {
                    const email_fragments = email.split("@");
                    const username = email_fragments.join(".");
                    WpAPI.getNonce().then((nonceResp) => {
                        if (nonceResp.data.status === 'ok') {
                            axiosInstance.post(`/api/user/generate_auth_cookie/`, qs.stringify({
                                insecure: "cool",
                                //username: username,
                                email: email,
                                password: password,
                                nonce: nonceResp.data.nonce
                            })
                            ).then((logRes) => {
                                if (logRes.data.status === 'ok') {
                                    Cookie.set('rbuser', logRes.data.cookie , { domain:  COOKIE_DOMAIN, path: "/"} );
                                    //stop tracking on trustpilot -- https://gitlab.dailyrssmail.com/growthlabs/resumebuilder.com-wpe/-/issues/1186
                                    //localStorage.setItem('tpuser', JSON.stringify(logRes.data.user));
                                    resolve({
                                        loginHash: logRes.data.cookie, 
                                        cookie_name: logRes.data.cookie_name, 
                                        auth_cookie_name: logRes.data.auth_cookie_name,
                                        user: logRes.data.user
                                    })
                                } else {
                                    if (logRes.data.error === 'Invalid username/email and/or password.') {
                                        reject("Invalid Email/Password");
                                    } else {
                                        reject(ucFirstWordOfSentence(logRes.data.error));
                                    }
                                }
                            }).catch((e) => {
                                reject("We encountered a problem. Please try again.");
                            })
                        } else {
                            reject("We encountered a problem. Please try again.")
                        }
                    }).catch((e) => {
                        reject("We encountered a problem. Please try again.")
                    })
                }
            } else {
                reject("Email is not valid")
            }
        })
    }
    static resetPassword(email) {
        return new Promise((resolve, reject) => {
            let emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
            if(email == '') reject("Email is required");
            if (emailRegex.test(email)) {
                const email_fragments = email.split("@");
                const username = email_fragments.join(".");
                axiosInstance.post(`/api/user/retrieve_password/`, qs.stringify({
                    insecure: "cool",
                    user_login: username
                })).then((res) => {
                    if (res.data.status === 'ok') {
                        resolve()
                    } else {
                        axiosInstance.post(`/api/user/retrieve_password/`, qs.stringify({
                            insecure: "cool",
                            user_login: email
                        })).then((res2) => {
                            if (res2.data.status === 'ok') {
                                resolve()
                            } else {
                                (res2.data.error.indexOf('The e-mail could not be sent.') !== -1 
                                ? reject("We encountered a problem. Please try again.") 
                                : reject(res2.data.error))
                            }
                        }).catch((e) => {
                            if (typeof e === 'string' && e.indexOf('The e-mail could not be sent.') !== -1) {
                                reject("We encountered a problem. Please try again.");
                            } else {
                                reject(e);
                            }
                        })
                    }
                }).catch((e) => {
                    if (typeof e === 'string' && e.indexOf('The e-mail could not be sent.') !== -1) {
                        reject("We encountered a problem. Please try again.");
                    } else {
                        reject(e);
                    }
                })
            } else {
                reject("Email is not valid");
            }
        })
    }
    static resetPasswordOnApp(data) {
        return new Promise((resolve, reject) => {
            axiosInstance.post(`/wp-admin/admin-ajax.php`, qs.stringify({
                ...data,
                insecure: "cool",
                action: 'rb_reset_password'
            })).then((res) => {
                resolve(res);
            }).catch((e) => {
                reject("We encountered a problem. Please try again..");
            })
        })
    }
    static loginUserResetPassword() {
        const loginHash = Cookie.get('rbuser');
        const frags = loginHash.split("|");
        const username = frags[0];
        return new Promise((resolve, reject) => {
            axiosInstance.post(`/api/user/retrieve_password/`, qs.stringify({
                insecure: "cool",
                user_login: username

            })).then((res) => {
                if (res.data.status === 'ok') {
                    resolve()
                } else {
                    reject("We encountered a problem. Please try again.");
                }
            }).catch((e) => {
                reject("We encountered a problem. Please try again.");
            })
        })
    }
    static saveMetaServer(resumesOfUser, resumes, loginHash, redirectUrl) {
        let resumeData = {};
        /**
         * Create all the json data for all the resumes it has for the user
         */
        _.each(resumesOfUser, (resumeKey) => {
            if (resumes && resumes[resumeKey]) {
                resumeData[resumeKey] = resumes[resumeKey];
            }
        })
        //return axiosInstance.post("/api/user/update_user_meta", qs.stringify({
        return axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify({
            action: 'rb_update_user_resume',
            insecure: "cool",
            cookie: loginHash,
            //meta_key: 'resume',
            //meta_value: JSON.stringify([resumeData])
            resume: JSON.stringify([resumeData])
        })).then((res) => {
            if (typeof redirectUrl != 'undefined') {
                window.location.href = redirectUrl;
            }
        }).catch((e) => {
            console.log(e)
        })
    }
    static uploadResume(f) {
        return new Promise((resolve, reject) => {
            let form_data = new FormData();
            form_data.append('file', f);
            form_data.append('action', 'rbapp_upload_file');
            if (f['type'] != 'application/pdf') {
                reject('Looks like you\'re trying to upload a format we can\'t accept. Please upload a PDF.')
                return
            }
            axiosInstance.post("/wp-admin/admin-ajax.php", form_data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(resp => {
                // debugger
                const resp1 = resp.data
                if (resp1.hasOwnProperty('error')) {
                    reject(resp1.error);
                    return
                }
                // else if( !resp1.hasOwnProperty('workhistory'))
                // console.log('print', resp)
                //prepare data
                // const r = Object.assign({}, { ...initialData.resume })
                const r = JSON.parse(JSON.stringify({ ...initialData.resume }))
                resp1.fname && (r.heading.fname = resp1.fname )
                resp1.fname && (r.heading.lname = resp1.lname )
                resp1.hasOwnProperty('city') && (r.heading.address = resp1.city)
                if (!resp1.hasOwnProperty('city') && resp1.hasOwnProperty('address')) (r.heading.address = resp1.address)
                resp1.hasOwnProperty('contactno') && (r.heading.phone = resp1.contactno)
                resp1.hasOwnProperty('email') && (r.heading.email = resp1.email)
                resp1.hasOwnProperty('title') && (r.heading.profession = resp1.title)
                r.portfolio = { set: { id_1: { label: 'LinkedIn', link: resp1.sociallinks.linkedin } } }
                // debugger
                if (resp1.hasOwnProperty('workhistory') && Object.keys(resp1.workhistory).length && resp1.workhistory[0] != undefined && resp1.workhistory[0].hasOwnProperty('profile')) {
                    delete r.work_history.jobs.job_1
                    r.work_history.edit_in_progress = { job: '', step: '' }
                    resp1.workhistory.forEach((element, index) => {
                        r.work_history.jobs = {
                            ...r.work_history.jobs, ['job_' + (Math.floor(Math.random() * 1000))]: {
                                job: {
                                    job_title: element.profile.hasOwnProperty('job_title') ? element.profile.job_title : '',
                                    employer: element.profile.hasOwnProperty('employer') ? element.profile.employer : '',
                                    city: element.profile.hasOwnProperty('location') ? element.profile.location : '',
                                    state: "",
                                    start_date: element.profile.hasOwnProperty('start') ? element.profile.start[0] + ' ' + element.profile.start[1] : '',
                                    end_date: (element.profile.hasOwnProperty('end') && element.profile.end[1] && element.profile.end[1].length) ? element.profile.end[0] + ' ' + element.profile.end[1] : '',
                                    currently_working: element.profile.present,
                                    description: element.profile.hasOwnProperty('summary') ? `<p>` + element.profile.summary + `</p>` : '',
                                }
                            }
                        }
                    });
                }
                if (resp1.hasOwnProperty('education') && Object.keys(resp1.education).length && resp1.education[0] != undefined && resp1.education[0].hasOwnProperty('profile')) {
                    delete r.education_history.all.education_1
                    r.education_history.edit_in_progress = { education: '', step: '' }
                    resp1.education.forEach((element, index) => {
                        r.education_history.all = {
                            ...r.education_history.all, ['education_' + (Math.floor(Math.random() * 1000))]: {
                                education: {
                                    school_name: element.profile.hasOwnProperty('school_name') ? element.profile.school_name : '',
                                    degree: element.profile.hasOwnProperty('degree') ? element.profile.degree : '',
                                    field_of_study: element.profile.hasOwnProperty('area_of_study') ? element.profile.area_of_study.trim() : '',
                                    school_location: "",
                                    start_date: element.profile.hasOwnProperty('start_date') ? element.profile.start_date[0] + ' ' + element.profile.start_date[1] : '',
                                    end_date: (element.profile.hasOwnProperty('end_date') && element.profile.end_date[1] && element.profile.end_date[1].length) ? element.profile.end_date[0] + ' ' + element.profile.end_date[1] : '',
                                    currently_studying: false,
                                    description: '',
                                }

                            }
                        }
                    });
                }
                if (resp1.hasOwnProperty('topskills') && Object.keys(resp1.topskills).length) {
                    delete r.skills.set.skill_1
                    resp1.topskills.forEach((element, index) => {
                        r.skills.set = {
                            ...r.skills.set, ['skill_' + (Math.floor(Math.random() * 1000))]: {
                                name: element,
                                rating: 0,
                            }
                        }
                    });
                    // r.skills.rating_disabled=true

                }
                if (resp1.hasOwnProperty('summary')) {
                    r.summary.content = `<p>` + resp1.summary + `</p>`
                }
                resolve(r)

            }).catch((e) => {
                reject(e);
            })
        })
    }
   
    static loadResumesInDashboard(callback) {
        let password = Cookie.get('op', { domain:  COOKIE_DOMAIN, path: "/"});
        const loginHash = Cookie.get('rbuser', { domain:  COOKIE_DOMAIN, path: "/"});
        const jsonData = localStorage.getItem('resumes');
        const resumes = JSON.parse(jsonData) ? JSON.parse(jsonData) : {};
        let updated_resumes = {};
        if (loginHash) {
            const frags = loginHash.split("|")
            let user_resumes = JSON.parse(localStorage.getItem(frags[0]));
            user_resumes = !_.isEmpty(user_resumes) && _.isArray(user_resumes) ? user_resumes : [];
            if(password){
                WpAPI.changeCookie().then((r) => { 
                    //axiosInstance.post(`/api/user/get_user_meta/`, qs.stringify(
                    axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(
                    {
                        action: 'rb_get_user_resume',
                        insecure: "cool",
                        cookie: r.loginHash,
                        //meta_key: "resume"
                    }
                )).then((res) => {
                    let resume = res.data.resume?.replace(/(\r\n|\n|\r)/gm, "");
                    let resTmp = JSON.parse(resume ? resume : "[]");
                    let resData = resTmp[0];
                    if (res.data.status == 'ok') {
                        if (_.isEmpty(resumes)) {
                            updated_resumes = {};
                            _.forOwn(resData, (value, key) => {
                                value = updateUserDbResume(value);
                                user_resumes.push(key);
                                updated_resumes[key] = value;
                            })
                        } else {
                            updated_resumes = _.merge({}, resumes)
                            _.forOwn(resData, (value, key) => {
                                value = updateUserDbResume(value);
                                if (_.indexOf(user_resumes, key) === -1) {
                                    user_resumes.push(key)
                                }
                                if (_.isEmpty(updated_resumes[key])) {
                                    updated_resumes[key] = value;
                                }
                            })
                        }
                    } else {
                        // If the user is not able to fetch any resume then start fresh
                        updated_resumes = {}
                        user_resumes = []
                    }
                    localStorage.setItem('resumes', JSON.stringify(updated_resumes));
                    localStorage.setItem(frags[0], JSON.stringify(user_resumes));
                    if(typeof callback == 'function') callback(updated_resumes);
                    // let allResumes = {}
                    // _.each(user_resumes, (value) => {
                    //     if(updated_resumes[value]){
                    //         allResumes[value] = updated_resumes[value];
                    //     }
                    // })
                    //dispatch(setInitialDataForLandingPage(loginHash, updated_resumes))
                })
                })
            }else{
                //axiosInstance.post(`/api/user/get_user_meta/`, qs.stringify(
                if(user_resumes?.length){
                        //No need load from database if already present
                        let resumes = JSON.parse(localStorage.getItem('resumes'));
                        if(typeof callback == 'function') callback(resumes);
                    }else axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(
                    {
                        action: 'rb_get_user_resume',
                        insecure: "cool",
                        cookie: loginHash,
                        //meta_key: "resume"
                    }
                )).then((res) => {
                    let resume = res.data.resume?.replace(/(\r\n|\n|\r)/gm, "");
                    let resTmp = JSON.parse(resume ? resume : "[]");
                    let resData = resTmp[0];
                    if (res.data.status == 'ok') {
                        if (_.isEmpty(resumes)) {
                            updated_resumes = {};
                            _.forOwn(resData, (value, key) => {
                                value = updateUserDbResume(value);
                                user_resumes.push(key);
                                updated_resumes[key] = value;
                            })
                        } else {
                            updated_resumes = _.merge({}, resumes)
                            _.forOwn(resData, (value, key) => {
                                value = updateUserDbResume(value);
                                if (_.indexOf(user_resumes, key) === -1) {
                                    user_resumes.push(key)
                                }
                                if (_.isEmpty(updated_resumes[key])) {
                                    updated_resumes[key] = value;
                                }
                            })
                        }
                    } else {
                        // If the user is not able to fetch any resume then start fresh
                        updated_resumes = {}
                        user_resumes = []
                    }
                    localStorage.setItem('resumes', JSON.stringify(updated_resumes));
                    localStorage.setItem(frags[0], JSON.stringify(user_resumes));
                    if(typeof callback == 'function') callback(updated_resumes);
                    // let allResumes = {}
                    // _.each(user_resumes, (value) => {
                    //     if(updated_resumes[value]){
                    //         allResumes[value] = updated_resumes[value];
                    //     }
                    // })
                    //dispatch(setInitialDataForLandingPage(loginHash, updated_resumes))
                }).catch((e) => {
                    console.log(e)
                })
            }
        } else {
            let offlineResumes = JSON.parse(localStorage.getItem('offlineResumes'));
            offlineResumes = !_.isEmpty(offlineResumes) && _.isArray(offlineResumes) ? offlineResumes : [];
            updated_resumes = !_.isEmpty(resumes) ? resumes : {};
            localStorage.setItem('resumes', JSON.stringify(updated_resumes));
            localStorage.setItem('offlineResumes', JSON.stringify(offlineResumes));

            let allResumes = {}
            _.each(offlineResumes, (value) => {
                if (updated_resumes[value]) {
                    allResumes[value] = updated_resumes[value];
                }
            })
            callback(allResumes)
            //dispatch(setInitialDataForLandingPage(loginHash, allResumes))
        }

    }
    static deleteResume(id) {
        let resumes = JSON.parse(localStorage.getItem('resumes'));
        const loginHash = Cookie.get('rbuser');
        resumes = resumes ? resumes : {};
        // let resumes_pool = Object.keys(resumes);


        if (resumes[id]) { delete resumes[id] }
        // resumes_pool = resumes_pool.filter(v => v != id)
        localStorage.setItem('resumes', JSON.stringify(resumes));
        if (loginHash) {
            const frags = loginHash.split("|")
            let login_resumes = JSON.parse(localStorage.getItem(frags[0]));
            login_resumes = login_resumes ? login_resumes : []
            login_resumes = login_resumes.filter(v => v != id)
            localStorage.setItem(frags[0], JSON.stringify(login_resumes));
            WpAPI.saveMetaServer(login_resumes, resumes, loginHash);
        } else {
            let previous_offline_resumes = JSON.parse(localStorage.getItem('offlineResumes'));
            previous_offline_resumes = previous_offline_resumes ? previous_offline_resumes : []
            previous_offline_resumes = previous_offline_resumes.filter(v => v != id)
            localStorage.setItem('offlineResumes', JSON.stringify(previous_offline_resumes));
        }
    }

    static deleteLetter(id) {
        let letters = JSON.parse(localStorage.getItem('letters'));
        const loginHash = Cookie.get('rbuser');
        letters = letters ? letters : {};
        
        if (letters[id]) delete letters[id]
        
        localStorage.setItem('letters', JSON.stringify(letters));
    
        if (loginHash) {
            const frags = loginHash.split("|")
            let login_letters = JSON.parse(localStorage.getItem(frags[0]));
            login_letters = login_letters ? login_letters : []
            login_letters = login_letters.filter(v => v != id)
            localStorage.setItem(frags[0], JSON.stringify(login_letters));
        }else{
            let previous_offline_letters = JSON.parse(localStorage.getItem('offlineletters'));
            previous_offline_letters = previous_offline_letters ? previous_offline_letters : []
            previous_offline_letters = previous_offline_letters.filter(v => v != id)
            localStorage.setItem('offlineletters', JSON.stringify(previous_offline_letters));
        }
        WpAPI.deleteLetterFromDB(id);
    }

    static deleteLetterFromDB(id){
                    axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(
            {
                action: 'rb_delete_coverletter',
                insecure: "cool",
                coverletter_id: id
            }
        )).then((res) => {
            console.log(res);
        });
    }

    static getPredefinedPoints(type, search_keywork, callback) {
        var data = new FormData();
        data.append('type', type);
        data.append('search_keyword', search_keywork);
        data.append('action', 'get_expert_points');

        axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
            resp.status == 200 ? callback(resp.data) : [];
        })
    }

    // static getCatAndTemplateMapping(category, callback) {
    //     var data = new FormData();
    //     data.append('job_category', category);
    //     data.append('action', 'get_template_mapping');

    //     axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
    //         console.log(resp)
    //         resp.status == 200 ? callback(resp.data) : [];
    //     })
    // }

    static getGeneratedPdf(rdata, callback) {
        var data = new FormData();
        data.append('actionType', 'generate');
        data.append('resumeContent', rdata.resumeHtml);
        data.append('resumeType', rdata.resumeType);

        axiosInstance.post("/wp-content/themes/resumebuilder/getPdf.php", data).then(resp => {
            resp.status == 200 ? callback(resp.data, 'pdf') : '';
        })
    }
    static getGeneratedPdf2(rdata, callback) {
        var data = new FormData();
        var tpls = PDFHeaderFooter(rdata.active_template, rdata?.active_color, rdata?.custom_template_color, rdata.type);
        // data.append('actionType', 'generate');
        // data.append('resumeContent', rdata.resumeHtml);
        // data.append('resumeType', rdata.resumeType);
        data.append('header', ( tpls.h ) );
        data.append('header1', (tpls.h1) );
        data.append('footer', (tpls.f));
        let vardata = {
            actionType: rdata.resumeType,
            header: tpls.h,
            header1: tpls.h1,
            footer: tpls.f,
            type: rdata.downloadtype ?? 'file'
        }
        const function_name = rdata.type == 'coverletter' ? 'generateLetterLink' : 'generateResumeLink';
        WpAPI[function_name](rdata.id, rdata.userId).then(resp => {
            data.append('url',btoa(resp?.link))
            vardata.url = btoa(resp?.link)
            const rurl = "/downloadresume/getPdfLink" 
            axiosInstance.post(rurl, vardata, { responseType: rdata.downloadtype ? 'json' : 'blob' }).then(resp => {
                if(resp.status == 200)  callback(resp.data, 'pdf')
                else{
                    alert("The resume download is not available at this time.\nPlease try after sometime later.");
                    throw new Error('User not able to download error. Response code is ' + resp.status);
                    
                } 
            })

        })
    }

    static getGeneratedDocx(rdata, callback) {
        var data = new FormData();
        data.append('actionType', 'generate');
        data.append('resumeContent', rdata.resumeHtml);
        data.append('resumeType', rdata.resumeType);

        axiosInstance.post("/wp-content/themes/resumebuilder/getDocx.php", data).then(resp => {
            resp.status == 200 ? callback(resp.data, 'docx') : '';
        })
    }

    static getGeneratedDocx2(rdata, callback) {
        var data = new FormData();
        var tpls = PDFHeaderFooter(rdata.active_template, rdata?.active_color, rdata?.custom_template_color, rdata.type);
        // data.append('actionType', 'generate');
        // data.append('resumeType', rdata.resumeType);
        data.append('header', ( tpls.h ) );
        data.append('header1', (tpls.h1) );
        data.append('footer', (tpls.f));
        let vardata = {
            // actionType: rdata.resumeType,
            header: tpls.h,
            header1: tpls.h1,
            footer: tpls.f,
            type: rdata.downloadtype ?? 'file'
        }
        const function_name = rdata.type == 'coverletter' ? 'generateLetterLink' : 'generateResumeLink';
        WpAPI[function_name](rdata.id, rdata.userId).then(resp => {
            data.append('url',btoa(resp?.link))
            vardata.url = btoa(resp?.link)
            const rurl = "/downloadresume/getDocxLink" 
            axiosInstance.post(rurl, vardata, { responseType: rdata.downloadtype ? 'json' : 'blob' }).then(resp => {
                if(resp.status == 200)  callback(resp.data, 'docx')
                else{
                    alert("The resume download is not available at this time.\nPlease try after sometime later.");
                    throw new Error('User not able to download error. Response code is ' + resp.status);
                } 
            })
        })
    }

    static getGeneratedText(rdata, callback) {
        var data = new FormData();
        data.append('actionType', 'generate');
        data.append('resumeContent', rdata.resumeHtml);
        data.append('resumeType', rdata.resumeType);

        axiosInstance.post("/wp-content/themes/rt/getText.php", data).then(resp => {
            resp.status == 200 ? callback(resp.data, 'text') : '';
        })
    }

    static getLoginUser(dispatch){
        const loginHash = Cookie.get('rbuser', { domain:  COOKIE_DOMAIN, path: "/"});
        if(loginHash){
            let password = Cookie.get('op', { domain:  COOKIE_DOMAIN, path: "/"});
            if(password){
                return WpAPI.changeCookie().then((r) => { 
                    axiosInstance.post("/api/user/get_currentuserinfo/", qs.stringify({ insecure: 'cool', cookie: r.loginHash })).then(resp => {
                        if(resp.data.status == 'error'){
                            WpAPI.logOut().then((res) => {
                                location.href = '/login/'
                            });
                        }else if(resp.data.status === 'ok'){
                            // const userIdEncoded = {id: encryptNumber(resp.data.user.id)}
                            // const user2 = Object.assign({}, resp.data.user, userIdEncoded)
                            dispatch(setLoginHash(r.loginHash, resp.data.user));
                            Cookie.remove('le', { domain: COOKIE_DOMAIN, path: "/" });
                            Cookie.remove('op', { domain: COOKIE_DOMAIN, path: "/" });
                            return true
                        }else{
                            return false;
                        }
                        //dispatch(setLoginHash(loginHash, resp.data.user));
                    }).catch((e) => {
                        console.log(e)
                        return false
                        // @todo Should do something here instead
                    })
                })
            }else{
                return axiosInstance.post("/api/user/get_currentuserinfo/", qs.stringify({ insecure: 'cool', cookie: loginHash })).then(resp => {
                    if(resp.data.status == 'error'){
                        WpAPI.logOut().then((res) => {
                            location.href = '/login/'
                        });
                    }else if(resp.data.status === 'ok'){
                        // const userIdEncoded = {id: encryptNumber(resp.data.user.id)}
                        // const user2 = Object.assign({}, resp.data.user, userIdEncoded)
                        dispatch(setLoginHash(loginHash, resp.data.user));
                        return true
                    }else{
                        return false;
                    }
                    //dispatch(setLoginHash(loginHash, resp.data.user));
                }).catch((e) => {
                    console.log(e)
                    return false
                    // @todo Should do something here instead
                })
            }
        }else{
            return Promise.resolve(false)
        }
    }

    static getLoginUserInfo() {
        return new Promise((resolve, reject) => {
            const loginHash = Cookie.get('rbuser');
            if (loginHash) {
                axiosInstance.post("/api/user/get_currentuserinfo/", qs.stringify({ insecure: 'cool', cookie: loginHash })).then(resp => {
                    // debugger
                    const resp1 = resp.data
                    if (resp1.hasOwnProperty('error')) {
                        reject(resp1.error);
                        return
                    }
                    resolve(resp)
                }).catch((e) => {
                    reject(e);
                })
            } else {
                reject({ status: 'error', msg: 'Not logged in' });
            }
        })
    }

    static isLoggedIn() {
        const loginHash = Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"});
        return loginHash ? true : false
    }
    static logOut() {
        const loginHash = Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"});

        if (loginHash) {
            let all = [];
            const frag = loginHash.split("|")
            let offlineids = JSON.parse(localStorage.getItem('offlineResumes'));
            let loginIds = JSON.parse(localStorage.getItem(frag[0]));
            let resumes = JSON.parse(localStorage.getItem('resumes'));
            const user_cl_name = `${frag[0]}_letters`;
            localStorage.removeItem("help_subject");
            if (offlineids != null && loginIds != null) {
                all = [...offlineids, ...loginIds]
            }
            else if (offlineids == null && loginIds != null) {
                all = [...loginIds];
            }
            else if (loginIds == null && offlineids != null) {
                all = [...offlineids]
            }
            //temp code for coverletter 
            //Cookie.remove('current_letter', { domain: COOKIE_DOMAIN, path: "/" })
            return WpAPI.saveMetaServer(all, resumes, loginHash, false).then(() => {
                Cookie.remove('rbuser', { domain: COOKIE_DOMAIN, path: "/" });
                Cookie.remove('current_resume', { domain: COOKIE_DOMAIN, path: "/" })
                Cookie.remove('current_letter', { domain: COOKIE_DOMAIN, path: "/" })
                Cookie.remove('redirect_to', { domain: COOKIE_DOMAIN, path: "/" })
                Cookie.remove(frag[0], {domain: COOKIE_DOMAIN, path: "/"})
                Cookie.remove('rb_utm_source', { domain: COOKIE_DOMAIN, path: "/" })
                Cookie.remove('dashboard_tab', { domain: COOKIE_DOMAIN, path: "/" })
                localStorage.removeItem('offlineResumes')
                localStorage.removeItem('offlineLetters')
                localStorage.removeItem(frag[0])
                localStorage.removeItem(user_cl_name)
                localStorage.removeItem('resumes')
                localStorage.removeItem('letters')
                //stop tracking on trustpilot -- https://gitlab.dailyrssmail.com/growthlabs/resumebuilder.com-wpe/-/issues/1186
                //localStorage.removeItem('tpuser')
                localStorage.removeItem('clickAction')
                localStorage.removeItem('downloadOnAllinonePageLoad')
                localStorage.removeItem('resumeName')
                window.location.href = SITE_DOMAIN;
            });

        }else{
            return Promise.resolve(false)
        }
    }

    static uploadPicture(p) {
        return new Promise((resolve, reject) => {
            var imgFormat = ['image/jpeg', 'image/jpg', 'image/png'];
            var data = new FormData();
            //data.append('type', type);
            data.append('data', p);
            data.append('action', 'save_profile_picture');
            if (!imgFormat.includes(p['type'].toLowerCase())) {
                reject('Uploaded file is not a jpg, jpeg or png file.')
                return
            }
            axiosInstance.post("/wp-admin/admin-ajax.php", data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(resp => {
                // debugger
                const resp1 = resp.data
                if (resp1.hasOwnProperty('error')) {
                    reject(resp1.error);
                    return
                }
                //const r = JSON.parse(JSON.stringify({ ...initialData.resume }))
                resolve(resp)

            }).catch((e) => {
                reject(e);
            })
        })

    }

    static uploadTopResumeFile(p) {
        return new Promise((resolve, reject) => {
            var allowExt = ['doc', 'docx', 'pdf', 'rtf']
            var data = new FormData();
            //data.append('type', type);
            var fileExt = this.getFileExtension(p.name);
            data.append('data', p);
            data.append('action', 'save_top_resume_file');
            if (!allowExt.includes(fileExt.toLowerCase())) {
                reject('The uploaded file must be a .doc, .pdf or .rtf file.')
                return
            }
            axiosInstance.post("/wp-admin/admin-ajax.php", data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(resp => {
                // debugger
                const resp1 = resp.data
                if (resp1.hasOwnProperty('error')) {
                    reject(resp1.error);
                    return
                }
                //const r = JSON.parse(JSON.stringify({ ...initialData.resume }))
                resolve(resp)

            }).catch((e) => {
                reject(e);
            })
        })

    }

    static submitTopResumeData(d) {
        return new Promise((resolve, reject) => {
            var data = new FormData();
            data.append('fname', d.fname);
            data.append('lname', d.lname);
            data.append('email', d.email);
            data.append('resume_file', d.resumefile);
            data.append('email_subscription', d.emailSubscription);
            // data.append('email_promotion', d.emailPromotion);
            // data.append('cover_letter', d.coverLetter);
            data.append('action', 'submit_topResume_data');

            axiosInstance.post("/wp-admin/admin-ajax.php", data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(resp => {
                // debugger
                const resp1 = resp.data
                if (resp1.hasOwnProperty('error')) {
                    reject(resp1.error);
                    return
                }
                //const r = JSON.parse(JSON.stringify({ ...initialData.resume }))
                resolve(resp)

            }).catch((e) => {
                reject(e);
            })
        })
    }

    static getFileExtension(name) {
        return name.split('.').pop();
    }

    static getAllMembershipLevel(callback) {
        var data = new FormData();
        data.append('include_hidden', false);
        data.append('use_cache', false);
        data.append('force', false);
        data.append('action', 'get_all_membership_levels');

        axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {

            resp.status == 200 ? callback(resp.data) : [];
        })
    }

    // static getCurrentUserInfo() {
    //     var data = new FormData();
    //     data.append('action', 'get_user_info');

    //     axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
    //         //console.log(resp.status);
    //         return (resp.status == 200) ? resp.data : [];
    //     })
    // }

    static setRedirectCookie(url) {
        Cookie.set('redirect_to', url, { domain: COOKIE_DOMAIN, path: '/' });
    }

    static loadJobCategories(callback) {
        var data = new FormData();
        data.append('action', 'get_job_categories');
        data.append('_r', Math.random());
        axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
            resp.status == 200 ? callback(resp.data) : [];
        })
    }

    static submitNeedHelpData(d) {
        return new Promise((resolve, reject) => {
            var data = new FormData();
            data.append('subject', d.subject);
            data.append('name', d.name);
            data.append('email', d.email);
            data.append('message', d.message);
            data.append('action', 'submit_need_help_data');

            axiosInstance.post("/wp-admin/admin-ajax.php", data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(resp => {
                // debugger
                const resp1 = resp.data
                if (resp1.hasOwnProperty('error')) {
                    reject(resp1.error);
                    return
                }
                resolve(resp)
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static changeCookie(){
        let email = Cookie.get('le');
        let password = Cookie.get('op');
        return new Promise((resolve, reject) => {
            WpAPI.getNonce().then((nonceResp) => {
                if (nonceResp.data.status === 'ok') {
                    axiosInstance.post(`/api/user/generate_auth_cookie/`, qs.stringify({
                        insecure: "cool",
                        //username: username,
                        email: email,
                        password: password,
                        nonce: nonceResp.data.nonce
                    })
                    ).then((logRes) => {
                        if (logRes.data.status === 'ok') {
                                Cookie.set('rbuser', logRes.data.cookie , { domain:  COOKIE_DOMAIN, path: "/"} );
                                Cookie.remove('le', { domain: COOKIE_DOMAIN, path: "/" });
                                Cookie.remove('op', { domain: COOKIE_DOMAIN, path: "/" });
                            resolve({
                                loginHash: logRes.data.cookie,
                                cookie_name: logRes.data.cookie_name,
                                auth_cookie_name: logRes.data.auth_cookie_name,
                                user: logRes.data.user
                            })
                        } else {
                            if (logRes.data.error === 'Invalid username/email and/or password.') {
                                reject("Invalid Email/Password");
                            } else {
                                reject(logRes.data.error);
                            }
                        }
                    }).catch((e) => {
                        reject("We encountered a problem. Please try again.");
                    })
                } else {
                    reject("We encountered a problem. Please try again.")
                }
            }).catch((e) => {
                reject("We encountered a problem. Please try again.")
            })
        })
    }

    static socialLogin(user_info, social_login) {
        return new Promise((resolve, reject) => {
                    axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify({action: 'social_login_api', data: user_info, social_login: social_login })).then(logRes => {
                if (logRes.data.status === 'ok') {
                    resolve({
                        status: logRes.data.status,
                        loginHash: logRes.data.cookie,
                        cookie_name: logRes.data.cookie_name,
                        auth_cookie_name: logRes.data.auth_cookie_name,
                        user: logRes.data.user,
                        account_type: logRes.data.account_type
                    })
                }else {
                    resolve({
                        error: logRes.data.error,
                        account_type: logRes.data.account_type
                    });
                }
            }).catch((e) => {
                reject("We encountered a problem. Please try again.");
            })
        }).catch((e) =>{
            reject('We encountered a problem. Please try again.');
        })
    }

    static generateResumeLink(resume_id, user_id){
        return new Promise((resolve, reject) => {
            let data = new FormData();
            data.append('action', 'get_resume_link');
            data.append('user_id', user_id)
            data.append('resume_id', resume_id);
            axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
                const res = resp.data
                if (res?.error) {
                    //reject(new Error(res.error));
                    return
                }
                resolve(res)
            }).catch((e) => {
                console.log(e);
            })
        }).catch(error => {
            console.log(error);
        });
    }

    static getSharedResume(user_id, resume_id){
        return new Promise((resolve, reject) => {
            let data = new FormData();
            data.append('action', 'get_shared_resume');
            data.append('user_id', user_id);
            data.append('resume_id', resume_id);
            axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
                const res = resp.data
                // if (res.hasOwnProperty('error')) {
                //     reject(res.error);
                //     return res;
                // }
                resolve(res)
            }).catch((e) => {
                console.log(e);
            })
        })
    }

    static duplicateResume(resume_id, resume_name = ''){
        return new Promise((resolve, reject) => {
            const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
            let currentResume  = uuidv4();
            if(!loginHash){
                const offlineResumes = JSON.parse(localStorage.getItem('offlineResumes') ?? '[]');
                offlineResumes.push(currentResume);
                localStorage.setItem('offlineResumes', JSON.stringify(offlineResumes));
            }
            if(window.location.pathname == '/'){
                Cookie.remove('current_resume', { domain: COOKIE_DOMAIN, path: '/' })
                Cookie.set('current_resume', currentResume, { domain: COOKIE_DOMAIN, path: '/' })
            }

            let resumes = JSON.parse(localStorage.getItem('resumes')) || {};
            let resume = resumes?.[resume_id];

            let rname = '';
            if(resume_name != ''){
                rname = resume_name;
            }else{
                resume_name = getResumeName({ ...resume });
                rname = `${resume_name}_Copy`;
            }
            delete resume.resume_link;
            resume = {
                ...resume,
                resume_name: rname,
                created_date: getDateTime(),
                modified_date: getDateTime()
            }
            resumes[currentResume] = resume;
            localStorage.setItem('resumes', JSON.stringify(resumes));
            const res = {
                resumes: resumes,
                resume: resume,
                currentResume: (window.location.pathname == '/' ? currentResume : resume_id)
            }
            resolve(res)
        })
    }

    static async duplicateLetterInLocalStorage(letter_id, letter_name = ''){
        try {
            return await new Promise((resolve, reject) => {
                const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
                const existing_id = letter_id ?? Cookie.get('current_letter', {domain: COOKIE_DOMAIN, path: "/"})
                const newid = uuidv4();
                // if (!loginHash) {
                //     const offlineLetters = JSON.parse(localStorage.getItem('offlineLetters') ?? '[]');
                //     offlineLetters.push(newid);
                //     localStorage.setItem('offlineLetters', JSON.stringify(offlineLetters));
                // }
                // if (window.location.pathname == '/') {
                //     Cookie.remove('current_letter', { domain: COOKIE_DOMAIN, path: '/' });
                //     Cookie.set('current_letter', newid, { domain: COOKIE_DOMAIN, path: '/' });
                // }
                const letters = JSON.parse(localStorage.getItem('letters'));
                let letter = letters[existing_id];
                //const fullname = (letter.from.fname != "" ? letter.from.fname : "Letter_Draft") + (letter.from.lname != "" ? "_" + letter.from.lname : "");
                let lname = '';
                if (letter_name != '') {
                    lname = letter_name;
                } else {
                    //lname = (letter.hasOwnProperty('letter_name') && letter.letter_name.length ? `${letter.letter_name}` : fullname) + '_Copy';
                    letter_name = getLetterName({ ...letter });
                    lname = `${letter_name}_Copy`;
                }
                //letters[newid] = letter
                delete letter.letter_link;
                letter = {
                    ...letter,
                    letter_name: lname,
                    created_date: getDateTime(),
                    modified_date: getDateTime()
                };
                letters[newid] = letter;
                // localStorage.setItem('letters', JSON.stringify(letters));
                const res = {
                    letters: letters,
                    letter: letter,
                    new_id: newid
                };
                resolve(res);
            });
        } catch (error) {
            console.log(error);
        }
    }

    static getPhraseDataByAI = (section, phrase) => {
        return new Promise((resolve, reject) => {
                    axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify({ action: 'rb_ai_phrase_builder', section: section, phrase: phrase})).then(resp => {
                const res = resp.data;
                if (res?.error) {
                    reject(res.error);
                }else if(!res?.output){ 
                    reject('No response');
                }else{
                    resolve(res);
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static getLetterByAI = (ques_ans_response) => {
        return new Promise((resolve, reject) => {
                    axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify({ action: 'rb_ai_coverletter_builder', ai_cl_request: ques_ans_response})).then(resp => {
                const res = resp.data;
                if (res?.error) {
                    reject(res.error);
                }else if(!res?.output){ 
                    reject('No response');
                }else{
                    // localStorage.setItem('aidata', JSON.stringify(res.output));
                    resolve(res);
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static fetchAccountInfo = async () => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/membership/info", qs.stringify({ insecure: 'cool', cookie: loginHash })).then(resp => {
                if(resp.data.status == 'error'){
                    WpAPI.logOut().then((res) => {
                        location.href = '/login/'
                    });
                }else{
                    resolve(resp.data);
                }
            }).catch((e) => {
                console.log(e)
                //reject(e);
            })
        })
    }

    static fetchInvoices = async () => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/membership/get_invoices",qs.stringify({ insecure: 'cool', cookie: loginHash })).then(resp => {
                resolve(resp.data);
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static fetchPaymentMethods = async () => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/membership/fetch_payment_methods",qs.stringify({ insecure: 'cool', cookie: loginHash })).then(resp => {
                resolve(resp.data.payment_methods);
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static cancelPlan = async () => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/membership/cancel_plan",qs.stringify({ insecure: 'cool', cookie: loginHash })).then(resp => {
                //console.log(resp);
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
                
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static createPaymentSession = async (planId) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/create_session",qs.stringify({ insecure: 'cool', cookie: loginHash, plan_id: planId })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static createPaymentInfoSession = async (planId) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/create_payment_info_session",qs.stringify({ insecure: 'cool', cookie: loginHash, plan_id: planId })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static verifyPaymentSession = async (sessionId) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/confirm_session",qs.stringify({ insecure: 'cool', cookie: loginHash, session_id: sessionId })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
                
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static verifyPaymentInfoSession = async (sessionId) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/confirm_payment_info_session",qs.stringify({ insecure: 'cool', cookie: loginHash, session_id: sessionId })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
                
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static getPaymentSession = async (sessionId) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/get_session",qs.stringify({ insecure: 'cool', cookie: loginHash, session_id: sessionId })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }


    static getPaymentInfoSession = async (sessionId) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/get_payment_info_session",qs.stringify({ insecure: 'cool', cookie: loginHash, session_id: sessionId })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static updatePaymentSession = async (sessionId, data) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/update_session",qs.stringify({ insecure: 'cool', cookie: loginHash, session_id: sessionId, data })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static updatePaymentInfoSession = async (sessionId, data) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/update_payment_info_session",qs.stringify({ insecure: 'cool', cookie: loginHash, session_id: sessionId, data })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static finalizeSession = async (sessionId, data) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/finalize_session",qs.stringify({ insecure: 'cool', cookie: loginHash, session_id: sessionId, data })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static finalizePaymentInfoSession = async (sessionId, data) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/finalize_payment_info_session",qs.stringify({ insecure: 'cool', cookie: loginHash, session_id: sessionId, data })).then(resp => {
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static createPaymentIntent = async (payload) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/create_payment_intent",qs.stringify({ insecure: 'cool', cookie: loginHash, payload: payload })).then(resp => {
                console.log(resp);
                console.log('res stat: ', resp.status)
                if(resp.status === 200){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
                
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static createPaymentInfoIntent = async (payload) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/create_payment_Info_intent",qs.stringify({ insecure: 'cool', cookie: loginHash, payload: payload })).then(resp => {
                console.log(resp);
                console.log('res stat: ', resp.status)
                if(resp.status === 200){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
                
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static calculateTax = async (payload) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/calculate_tax",qs.stringify({ insecure: 'cool', cookie: loginHash, payload: payload })).then(resp => {
                console.log(resp);
                console.log('res stat: ', resp.status)
                if(resp.status === 200){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static retrieveCoupon = async (payload) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/checkout/retrieve_coupon",qs.stringify({ insecure: 'cool', cookie: loginHash, payload: payload })).then(resp => {
                console.log(resp);
                console.log('res stat: ', resp.status)
                if(resp.status === 200){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static activatePlan = async (sessionId) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/membership/activate_plan",qs.stringify({ insecure: 'cool', cookie: loginHash, session_id: sessionId })).then(resp => {
                //console.log(resp);
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }
                
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static getPlans = async () => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/membership/get_plans",qs.stringify({ insecure: 'cool', cookie: loginHash})).then(resp => {
                //console.log(resp);
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }   
            }).catch((e) => {
                reject(new Error(e));
            })
        })
    }

    static saveProfileData = async (firstname, lastname, password) => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/membership/save_profile",qs.stringify({ 
                insecure: 'cool',
                cookie: loginHash,
                firstname,
                lastname,
                password
            })).then(resp => {
                //console.log(resp);
                if(resp.data.status == 'ok'){
                    resolve(resp.data);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }   
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static deleteProfile = async () => {
        const loginHash = Cookie.get('rbuser', { domain: COOKIE_DOMAIN, path: '/' });
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/membership/delete_profile",qs.stringify({ 
                insecure: 'cool',
                cookie: loginHash,
            })).then(resp => {
                //console.log(resp);
                if(resp.data.status == 'ok'){
                    // If the user is deleted successfully then delete everything
                    const frag = loginHash.split("|");
                    Cookie.remove('rbuser', { domain: COOKIE_DOMAIN, path: "/" });
                    Cookie.remove('current_resume')
                    Cookie.remove('redirect_to', { domain: COOKIE_DOMAIN, path: "/" })
                    Cookie.remove(frag[0])
                    localStorage.removeItem('offlineResumes')
                    localStorage.removeItem(frag[0])
                    localStorage.removeItem('resumes')
                    resolve(true);
                }else if(resp.data.status == 'error'){
                    reject(resp.data.error);
                }else{
                    reject("Unknown Error");
                }   
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static saveUserEmailPreferences(userData) {
        const loginHash = Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"});
        return new Promise((resolve, reject) => {
            axiosInstance.post("/api/user/update_user_meta", qs.stringify({
                insecure: "cool",
                cookie: loginHash,
                meta_key: 'email_preferences',
                meta_value: JSON.stringify(userData)
            })).then((res) => {
                if(res.data.status == 'ok'){
                    resolve(res);
                }else if(res.data.status == 'error'){
                    reject(res.data.error);
                }else{
                    reject("Unknown Error");
                }   
            }).catch((e) => {
                reject(e);
            })
        })
    }

    static membership(dispatch, plan, lastsync, callback = false, forcechange = false) {
        let currentAccount = {}
        return new Promise((resolve, reject) => {
            if(PAID_SERVICES && WpAPI.isLoggedIn()){
                if(((parseInt(lastsync)+parseInt(ACCOUNT_SYNC)) <= (Math.floor(Date.now() / 1000))) || forcechange){
                    currentAccount = {plan: 'pro', 
                    lastsync: Math.floor(Date.now() / 1000), 
                    has_plan: true,
                    plan_has_trial: false,
                    plan_status: 'active'
                }
                    dispatch(setMembershipData(currentAccount));
                    // if(typeof callback == 'function') setSleep(10000);
                    if(typeof callback == 'function') callback(plan, data.user)
                    
                    // WpAPI.fetchAccountInfo().then((data) => {
                    //     const has_plan = (data?.plan && (data.plan != null) ? true : false);
                    //     const plan = (
                    //         data?.plan 
                    //         && (
                    //             data.plan.status == 'ACTIVE' 
                    //             || data.plan.status == 'CANCELLED'
                    //         ) 
                    //         ? 'pro' 
                    //         : 'basic'
                    //     );
                    //     const plan_has_trial = (data?.plan && data.plan.has_trial);
                    //     const plan_status = (data?.plan && data.plan.status);
                    //     currentAccount = {
                    //         has_plan: has_plan,
                    //         plan: plan, 
                    //         plan_has_trial: plan_has_trial, 
                    //         plan_status: plan_status, 
                    //         lastsync: Math.floor(Date.now() / 1000)
                    //     }
                    //     dispatch(setMembershipData(currentAccount));
                    //     resolve(currentAccount)
                    //     if(typeof callback == 'function') callback(plan, data.user)
                    // }).catch((e) => {
                    //     console.log(e);
                    //     /**
                    //      * Commented the below code as this was giving the error of 
                    //      * "Unhandled Promise Rejection: Error: Network Error."
                    //      * Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/575
                    //      * Date: 2024-01-19
                    //      */
                    //     //reject(e);
                    //     /**
                    //      * END
                    //      */
                    // })
                }else if(plan != null){
                    if(typeof callback == 'function') callback(plan)
                }
            }else{
                if(typeof callback == 'function') callback(plan)
            }
        })
    }

    static userCompletesSectionsDownloadsPrintsOrShares(resume){
        return new Promise((resolve, reject) => {
            let completed_sections = [];
            let completed = false;
            if(!resume?.user_completes_sections_downloads_prints_or_shares){
                if(resume.heading.fname != '' && resume.heading.lname != '') completed_sections.push('heading')
                if (Array.isArray(resume.skipped_sections) && resume.skipped_sections.includes('work_history')) {
                    completed_sections.push('work_history')
                }else if(Array.isArray(resume.skipped_sections) && !resume.skipped_sections.includes('work_history')){
                    const workhistory = resume.work_history;
                    Object.keys(workhistory.jobs).map((job_id, index) => {
                        const job = workhistory.jobs[job_id].job;
                        if(job.job_title != '' 
                            && job.employer != '' 
                            && !completed_sections.includes('work_history')){
                            completed_sections.push('work_history');
                        }
                    });
                }
                if (Array.isArray(resume.skipped_sections) && resume.skipped_sections.includes('education_history')) {
                    completed_sections.push('education_history')
                }else if(Array.isArray(resume.skipped_sections) && !resume.skipped_sections.includes('education_history')){
                    const educationhistory = resume.education_history;
                    Object.keys(educationhistory.all).map((education_id, index) => {
                        const education = educationhistory.all[education_id].education;
                        if(education.school_name != '' 
                            && education.school_location != '' 
                            && !completed_sections.includes('education_history')){
                            completed_sections.push('education_history');
                        }
                    });
                }
                if(completed_sections.length === 3) completed = true;
            }
            resolve({completed: completed})
        })
    }
    static linklocalResumeToUser(){
        //send ajax request to map all local saved resumes to user id
        const localresumes = localStorage.getItem('offlineResumes');
        const localresumes_ = JSON.parse(localresumes)
        if(!(localresumes_ && localresumes_.length)) return

        let request = {
            action: 'rb_user_link_resumes_progress',
            resumes: localresumes_,
        }

        const loginHash = Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"});
        if(WpAPI.isLoggedIn() && localresumes_.length){
            request.cookie = loginHash
                    axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(request)).then(resp => {
                //console.log(resp);
                if(resp.data.status == 'ok'){ //Do nothing
                }
               else if(resp.data.status == 'error'){
                // Sentry.captureMessage(resp.data.error);
            }else{
                // Sentry.captureMessage('Unknown error in linklocalResumeToUser');
            } 
            }).catch((e) => {
                // Sentry.captureMessage('Unknown error in linklocalResumeToUser');
            })
     }

    }
    static saveResmeProgress(data){

        let _d = hash(data);
        let request = {
            action: 'rb_user_resume_progress',
            resume_id: Cookie.get('current_resume'),
            ...data
        }
        const tracked = Cookie.get(`rb_tracker_${request.resume_id}`, {domain: COOKIE_DOMAIN, path: "/"});
        if(tracked && tracked == _d) return //Duplicate, right now just handling 1time add

        const loginHash = Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"});
        WpAPI.isLoggedIn() && (request.cookie = loginHash)
                    axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(request)).then(resp => {
            //console.log(resp);
            if(resp.data.status == 'ok'){
                Cookie.set(`rb_tracker_${request.resume_id}`,_d, {domain: COOKIE_DOMAIN, path: "/"});
                // resolve(true);
            }
            // else if(resp.data.status == 'error'){
            //     reject(resp.data.error);
            // }else{
            //     reject("Unknown Error");
            // }
        }).catch((e) => {
            console.log(e);
            // reject(e);
        })

    }

    static fetchActiveLetter = (dispatch, callback = false) => {
        const loginHash = Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"});
        let currentLetter = Cookie.get('current_letter', {domain: COOKIE_DOMAIN, path: "/"});
        const jsonData = localStorage.getItem('letters');
        const letters = JSON.parse(jsonData ? jsonData : "{}");
        // const offlineLetters = JSON.parse(localStorage.getItem('offlineLetters') ?? '[]');

        // If the user is logged in
        if (loginHash) {
            const frags = loginHash.split("|")
            const users_cl_name = frags[0]+'_letters';
            let lettersOfUser = []; // Initialize as an empty array initially
            if (isLocalStorageAvailable()) {
                lettersOfUser = JSON.parse(localStorage.getItem(users_cl_name) ?? '[]');
            } else {
                console.warn("Fetch Active Letter: LocalStorage is not available.");
            }
            // If there are letters but there is no value for currentLetter
            // of that value is invalid
            if (!currentLetter) {
                // Create a new resume id
                currentLetter = uuidv4();
                // Also set it into the cookie to make sure it persist
                Cookie.set('current_letter', currentLetter, { domain: COOKIE_DOMAIN, path: '/' });
                dispatch(initializeCoverletter(loginHash, currentLetter))
                if (typeof callback == 'function') callback()
            }
            // If current letter is not in the user's bucket then add it
            else if (_.indexOf(lettersOfUser, currentLetter) === -1) {
                lettersOfUser.push(currentLetter)
                localStorage.setItem(users_cl_name, JSON.stringify(lettersOfUser))
                // Also set it into the cookie to make sure it persists
                Cookie.set('current_letter', currentLetter, { domain: COOKIE_DOMAIN, path: '/' });
                dispatch(initializeCoverletter(loginHash, currentLetter, letters[currentLetter]))
                if (typeof callback == 'function') callback()
            } else {
                // Everything is there
                dispatch(initializeCoverletter(loginHash, currentLetter, letters[currentLetter]))
                if (typeof callback == 'function') callback()
            }
        } //No concept for offline coverletter
        // else {
        //     const offlineLetters = JSON.parse(localStorage.getItem('offlineLetters'));
        //     if (!currentLetter) {
        //         currentLetter = uuidv4();
        //         Cookie.set('current_letter', currentLetter, { domain: COOKIE_DOMAIN, path: '/' });
        //         dispatch(initializeCoverletter(loginHash ? loginHash : null, currentLetter));
        //         if (typeof callback == 'function') callback()
        //     } else if (!(_.isArray(offlineLetters) && _.indexOf(offlineLetters, currentLetter) !== -1 && letters[currentLetter])) {
        //         currentLetter = uuidv4();
        //         Cookie.set('current_letter', currentLetter, { domain: COOKIE_DOMAIN, path: '/' });
        //         dispatch(initializeCoverletter(loginHash ? loginHash : null, currentLetter));
        //         if (typeof callback == 'function') callback()
        //     } else {
        //         console.log('set it from here')
        //         dispatch(initializeCoverletter(loginHash ? loginHash : null, currentLetter, letters[currentLetter]))
        //         if (typeof callback == 'function') callback()
        //     }
        // }
    }

    static saveCoverLetter = (state, todb = false, letter_id = null) => {
        let id = letter_id ?? Cookie.get('current_letter', {domain: COOKIE_DOMAIN, path: "/"});
        let letters = JSON.parse(localStorage.getItem('letters'));
        letters = letters ? letters : {};
        if (id) {
            // Update the resume
            letters[id] = state.coverletter;
            localStorage.setItem('letters', JSON.stringify(JSON.parse(JSON.stringify(letters))));
            if (state.loginHash) {
                const frags = state.loginHash.split("|");
                const users_cl_name = frags[0]+'_letters';
                let lettersOfUser = JSON.parse(localStorage.getItem(users_cl_name));
                lettersOfUser = _.isArray(lettersOfUser) ? lettersOfUser : [];
                if (_.indexOf(lettersOfUser, id) === -1) {
                    lettersOfUser.push(id);
                    localStorage.setItem(users_cl_name, JSON.stringify(lettersOfUser));
                }
            } 
            // else {
            //     let offlineLetters = JSON.parse(localStorage.getItem('offlineLetters'));
            //     offlineLetters = _.isArray(offlineLetters) ? offlineLetters : [];
            //     if (_.indexOf(offlineLetters, currentLetter) === -1) {
            //         offlineLetters.push(currentLetter);
            //         localStorage.setItem('offlineLetters', JSON.stringify(offlineLetters));
            //     }
            // }
            // save the current letter into the database
            todb && WpAPI.saveCoverLetterIntoDB(state.coverletter, state.loginHash, letter_id);
        }
    }

    static async saveCoverLetterIntoDB(letter, loginHash, letter_id = null) {
        let id = letter_id ?? Cookie.get('current_letter', {domain: COOKIE_DOMAIN, path: "/"});
        let letterData = {};
        const payloadData = {
            action: 'rb_update_coverletter',
            insecure: "cool",
            cookie: loginHash ?? null,
            coverletter: JSON.stringify({...letterData, [id]: letter})
        }
        const res = await axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(payloadData));
        if (typeof redirectUrl != 'undefined') {
            window.location.href = redirectUrl;
        }
    }
    //forcereload only used in index.js for first time or reload
    static loadCoverLettersInDashboard(callback = false, forcereload = false) {
        let password = Cookie.get('op', { domain:  COOKIE_DOMAIN, path: "/"});
        const loginHash = Cookie.get('rbuser', { domain:  COOKIE_DOMAIN, path: "/"});
        // let letters = JSON.parse(localStorage.getItem('letters'));
        if(loginHash){
            if(password){
                //Unused
                WpAPI.changeCookie().then(r => WpAPI.loggedInDashboardLetters(r.loginHash, callback))
            }else{
                WpAPI.loggedInDashboardLetters(loginHash, callback, forcereload);
            }
        }
        // else{
            // let offlineLetters = JSON.parse(localStorage.getItem('offlineLetters'));
            // offlineLetters = !_.isEmpty(offlineLetters) && _.isArray(offlineLetters) ? offlineLetters : [];

            // letters = !_.isEmpty(letters) ? letters : {};

            // localStorage.setItem('letters', JSON.stringify(letters));
            // localStorage.setItem('offlineLetters', JSON.stringify(offlineLetters));

            // let allLetters = {}
            // _.each(offlineLetters, (value) => {
            //     if (letters[value]) {
            //         allLetters[value] = letters[value];
            //     }
            // })

            // if (typeof callback == 'function') callback(allLetters)
        // }
    }

    static loggedInDashboardLetters(loginHash, callback = false, forcereload = false){
        let updated_letters = {}
        const frags = loginHash.split("|")
        const users_cl_name = frags[0]+'_letters';
        let user_letters = JSON.parse(localStorage.getItem(users_cl_name));
        user_letters = !_.isEmpty(user_letters) && _.isArray(user_letters) ? user_letters : [];
        if(!forcereload && user_letters?.length){
            //No need load from database if already present
            let letters = JSON.parse(localStorage.getItem('letters'));
            if(typeof callback == 'function') callback(letters);
        }else axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(
            {
                action: 'rb_get_coverletter',
                insecure: "cool",
                cookie: loginHash
            }
        )).then((res) => {
            if (res.data.status == 'ok') {
                let resLetters = res.data.coverletter;
                if(Object.keys(resLetters).length){
                    _.forOwn(resLetters, (value, key) => {
                        if (_.indexOf(user_letters, key) === -1) {
                            user_letters.push(key)
                        }
                        if(!updated_letters.hasOwnProperty(key)){
                            updated_letters[key] = JSON.parse(value)
                        }
                    })
                }
            }
            const maxSize = 5 * 1024 * 1024; // 5 MB limit for localStorage
            const updatedLettersJSON = JSON.stringify(updated_letters);
            if (updatedLettersJSON.length <= maxSize) {
                localStorage.setItem('letters', updatedLettersJSON);
            } else {
                console.warn('Logged in Dashboard Letters: Data too large for localStorage, consider a different storage solution!');
            }
            const userLettersJSON = JSON.stringify(user_letters);
            if (userLettersJSON.length < maxSize) {
                localStorage.setItem(users_cl_name, userLettersJSON);
            } else {
                console.warn("Logged in Dashboard User Letters: Not enough storage space, consider cleaning up!");
            }
            if(typeof callback == 'function') callback(updated_letters);
        })
    }

    static linkLocalCoverLetterToUser(dispatch){
        return new Promise((resolve, reject) => { 
            //send ajax request to map all local saved coverletters to user id
            const localLetters = localStorage.getItem('offlineLetters');
            const localLetters_ = JSON.parse(localLetters)
            
            if(!(localLetters_ && localLetters_.length)) return

            let request = {
                action: 'rb_user_link_coverletter',
                coverletter: localLetters_,
            }

            const loginHash = Cookie.get('rbuser', {domain: COOKIE_DOMAIN, path: "/"})

            if(WpAPI.isLoggedIn() && localLetters_.length){
                request.cookie = loginHash
                axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(request)).then(resp => {
                    if(resp.data.status == 'ok'){ 
                        //localStorage.setItem('offlineLetters', JSON.stringify([]));
                        WpAPI.fetchActiveLetter(dispatch, () => {
                            WpAPI.loadCoverLettersInDashboard((letters) => {
                                resolve(letters)
                            })
                        })
                    }else if(resp.data.status == 'error'){
                        // Sentry.captureMessage(resp.data.error);
                    }else{
                        // Sentry.captureMessage('Unknown error in linkLocalCoverLetterToUser');
                    } 
                }).catch((e) => {
                    // Sentry.captureMessage('Unknown error in linkLocalCoverLetterToUser');
                })
            }
        }).catch(error => {
            console.log(error)
            // Sentry.captureMessage(error);
        })
    }
    static generateLetterLink(id, uid){
        return new Promise((resolve, reject) => {
            let data = new FormData();
            data.append('action', 'get_letter_link');
            data.append('uid', uid);
            data.append('lid', id);
            axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
                const res = resp.data
                // if (res.hasOwnProperty('error')) {
                //     reject(res.error);
                //     return res;
                // }
                resolve(res)
            }).catch((e) => {
                console.log(e);
            })
        })
    }
    static getSharedLetter(uid, id){
        return new Promise((resolve, reject) => {
            let data = new FormData();
            data.append('action', 'get_shared_letter');
            data.append('uid', uid);
            data.append('lid', id);
            axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
                const res = resp.data
                // if (res.hasOwnProperty('error')) {
                //     reject(res.error);
                //     return res;
                // }
                resolve(res)
            }).catch((e) => {
                console.log(e);
            })
        })
    }

    static getJobTitles(c){
        return new Promise((resolve, reject) => {
            let data = new FormData();
            data.append('action', 'job_titles');
            data.append('phrase', c);
            axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
                const res = resp.data
                // if (res.hasOwnProperty('error')) {
                //     reject(res.error);
                //     return res;
                // }
                resolve(res)
            }).catch((e) => {
                console.log(e);
            })
        })
    }
    static getJobSkills(c){
        return new Promise((resolve, reject) => {
            let data = new FormData();
            data.append('action', 'job_skills');
            data.append('job_title', c);
            axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
                const res = resp.data
                // if (res.hasOwnProperty('error')) {
                //     reject(res.error);
                //     return res;
                // }
                resolve(res)
            }).catch((e) => {
                console.log(e);
            })
        })
    }

    static getMembershipCancellationTestMode = async () => {
        let request = {
            action: 'get_membership_cancellation_test_mode',
        }
        return new Promise((resolve, reject) => {
                    axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(request)).then(res => {
                if(res.data.status == 'ok')
                    resolve({test_mode: res.data.test_mode})
                else
                    resolve({test_mode: false})
            }).catch((e) => {
                console.log(e)
            })
        })
    }
    static reviewResume(state, section) {
        let req = {
            body: {
                filter: {
                    review: {
                        type: "full",
                        section: "personal"
                    }
                },
                data:{
                    resume: {...state.resume}
                }
                
            }

        }
        return new Promise((resolve, reject) => {
            axiosInstance.post("/review/resume/", req).then(res => {
                resolve(res.data)
            }).catch((e) => {
                console.log(e)
            })
        })

    }
    static getShowCaseResume = (id, callback = false) =>{
        const request = {
            action: 'get_showcase_resume',
            showcase_id: id
        }
                    axiosInstance.post("/wp-admin/admin-ajax.php", qs.stringify(request)).then(res => {
            console.log(res.data.status)
            if(res.data.status == 'ok'){
                
                if (typeof callback == 'function') { callback(res.data.resume) }
            }
            else console.log('not ok')
          
        }).catch((e) => {
            console.log(e)
        })
        
    }

    static checkShowcaseEligible(userId) {
        return new Promise((resolve, reject) => {
            let data = new FormData();
            data.append('action', 'air_check_showcase_eligible');
            data.append('user_id', userId);
            axiosInstance.post("/wp-admin/admin-ajax.php", data).then(resp => {
                resolve(resp.data);
            }).catch(reject);
        });
    }

    static submitShowcaseQueue(userId, items, email) {
        return axiosInstance.post("/wp-admin/admin-ajax.php?action=air_submit_showcase_queue", JSON.stringify({
            user_id: userId,
            email: email,
            items: items,
        }), {
            headers: { 'Content-Type': 'application/json' }
        }).then(resp => resp.data);
    }

    /**
     * Fetch the paid-transition paywall status from the REST API.
     * Returns a promise resolving to { paywall_active: bool, deadline: string }.
     * Cached in sessionStorage for the lifetime of the browser tab.
     */
    static getTransitionStatus() {
        const CACHE_KEY = 'ro_transition_status';
        const cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) {
            try { return Promise.resolve(JSON.parse(cached)); } catch(e) {}
        }
        return axiosInstance.get('/wp-json/ro/v1/transition-status')
            .then(res => {
                const data = res.data || {};
                sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
                return data;
            })
            .catch(() => ({ paywall_active: false, deadline: null }));
    }

}